<template>
  <div id="home-tabs" ref="homeSubNav">
    <ul class="tabs transparent hide" ref="tabs">
      <li
        @click="$_selectTab(x.value)"
        class="tab"
        v-for="(x, index) in tabs"
        :key="index"
      >
        <a :href="`#${x.value}`">{{ x.name }}</a>
      </li>
    </ul>
    <!--     <div
      class="tab"
      v-for="({ name }, index) in tabs"
      :key="index"
      :id="`home-sub-nav_${name}`"
      :ref="`home-sub-nav_${name}`"
      @click="$_selectTab(name)"
    >
      <div class="text">{{ name }}</div>
      <div
        class="tab-border"
        :class="{
          'amber ligthen-1 move-border': selectedTab === name.toLowerCase(),
        }"
      ></div>
    </div> -->
  </div>
</template>
<script>
import M from 'materialize-css'
export default {
  name: "HomeSubNavigation",
  props: {},
  data() {
    return {
      selectedTab: "surveys",
      selectedIndex: 0,
      tabs: [
        {
          name: "Assessments",
          value:"Surveys"
        },
   /*      {
          name: "Tools",
        }, */
        {
          name: "Media",
          value:"Media"
        },
        {
          name: "Calculators",
          value:"Calculators"
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.tabInstance = M.Tabs.init(this.$refs.tabs, {});
      // console.log(this.$refs.tabs)
    }, 500);
  },
  computed: {},
  methods: {
    $_selectTab(tab) {
      this.selectedTab = tab.toLowerCase();
      this.$emit("updateTab", this.selectedTab);

      /** Scroll window to sub navigation element **/
      const scrollToElement = () => {
        // Get element through ref
        const elToScrollTo = this.$refs.homeSubNav;
        // Get top offset position
        const topOffSet = elToScrollTo.getBoundingClientRect().top;

        // Scroll by distance of sub nav from top
        setTimeout(() => {
          window.scrollBy({
            top: topOffSet - 65, // 65 - height of AppTopBar
            left: 0,
            behavior: "smooth",
          });
        });
      };

   /*    scrollToElement(); */
    },
  },
};
</script>
<style lang="scss" scoped>
#home-tabs {
  .tabs {
    /* border-bottom: 1px solid rgba(0, 0, 0, 0.1); */
    .tab {
      a {
        font-size: 17px;
        line-height: 52px;
        letter-spacing: .75px;
        font-family: 'Open Sans', sans-serif;
        font-weight: 500;
        position: relative;
        &.active {
          &::before { 
            content: '';
              position: absolute;
              left: 2px;
              top: 4px;
              width: calc(100% - 4px);
              height: calc(100% - 4px);
              background:rgba(255, 171, 0, 0.14);
              border-radius: 32px;
          }
        }
      }
    }
  }
}
/* #home-tabs {
  position: relative;
  margin-top: 1.5rem;
  display: flex;
  overflow-x: scroll;

  .tab {
    position: relative;
    margin-right: 2rem;
    .text {
      color: #636363;
      font-weight: 600;
      font-size: 18px;
      margin-bottom: 5px;
    }
    .tab-border {
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translate(-50%, 0);
      width: 80%;
      height: 3px;
      border-radius: 5px;
    }

    .move-border {
      animation: moveTabBorder 0.3s;
    }

    @keyframes moveTabBorder {
      0% {
        left: -10%;
      }
      100% {
        left: 50%;
      }
    }
  }
} */
</style>
<style lang="scss">
#home-tabs {
  .indicator {
    position: absolute;
    bottom: 0;
    will-change: left, right;
    border: 2px solid #ffca28;
    height: calc(100% - 4px);
    border-radius: 32px;
    background-color: transparent;
    margin: 0px !important
  }
}
</style>